import { render, staticRenderFns } from "./print-queue.vue?vue&type=template&id=567c35dc&scoped=true&"
import script from "./print-queue.vue?vue&type=script&lang=js&"
export * from "./print-queue.vue?vue&type=script&lang=js&"
import style0 from "./print-queue.vue?vue&type=style&index=0&id=567c35dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567c35dc",
  null
  
)

export default component.exports